export default {
  data() {
    return {
      list: [],
      // 产品id
      product_id: null,
      //项目id
      project_id: null,
      // 根据获取的数据决定url
      url: '',
      // 规则数组
      // 0：系统自动评分  1：辅导员评分  2：项目心得500字
      rules: [
        {
          value: 0,
          rule: '系统自动评分',
        },
        {
          value: 1,
          rule: '辅导员评分',
        },
        {
          value: 2,
          rule: '项目心得500字',
        },
      ]
    }
  },
  methods: {
    submit() {
      const flag1 = this.handlePhaseScore()
      const flag2 = this.handleCourseScore()
      const flag3 = this.handleChapterScore()
      if (flag1 && flag2 && flag3) {
        this.$message({
          message: '提交成功',
          type: 'success'
        });
        const data = {
          token: this.$store.state.authority_management,
          resources: JSON.stringify(this.list),
          product_id: this.product_id,
          shop_id: this.$store.state.store.id,
        }
        this.$post(this.url, data).then(res => {
          this.$router.push('/itemproductlist')
        })
      }
    },
    //返回按钮
    back(){
      this.$router.push('/itemproductlist');
    },

    // 处理阶段分数百分比
    handlePhaseScore() {
      let phaseScore = 0
      const list = this.list
      for (let i = 0; i < list.length; i++) {
        phaseScore += Number(list[i].percentage)
      }
      if (phaseScore !== 100) {
        this.$message.error('所有阶段百分比总和应为100%');
        phaseScore = 0
        return false
      }
      phaseScore = 0
      this.list = list
      return true
    },

    // 处理课程分数百分比
    handleCourseScore() {
      let courseScore = 0
      const list = this.list
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].task_activities.length; j++) {
          courseScore += Number(list[i].task_activities[j]['percentage'])
        }
        if (courseScore !== 100) {
          this.$message.error('每个课程百分比总和应为100%');
          courseScore = 0
          return false
        }
        courseScore = 0
      }
      this.list = list
      return true
    },

    // 处理章节分数百分比
    handleChapterScore() {
      let chapterScore = 0
      const list = this.list
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].task_activities.length; j++) {
          for (let k = 0; k < list[i].task_activities[j].resources.length; k++) {
            chapterScore += Number(list[i].task_activities[j].resources[k]['percentage'])
          }
          if (chapterScore !== 100) {
            this.$message.error('每个章节的百分比总和应为100%');
            chapterScore = 0
            return false
          }
          chapterScore = 0
        }
      }
      this.list = list
      return true
    },

    // 选择器选中的值发生变化
    handleSelectChange (event, obj) {
      const rule = Number(event.target.value)
      obj.rule = rule
    },

    // 什么也不做
    doSomething () {},

    // 初始化数组对象
    initList() {
      const that = this
      const data = {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 100,
        project_id: this.project_id
      }
      that.$post('project_tasks/search_group_by_task', data).then(res => {
        that.list = res.data.result.data.map(item => {
          // item为项目里的每个阶段
          // 循环item是为了将课程下的字符串表示的章、节转换成对象数组
          for (let i = 0; i < item.task_activities.length; i++) {
            item.task_activities[i].resources = JSON.parse(item.task_activities[i].resources)
          }
          return item
        })
  
        let list = that.list
        for (let i = 0; i < list.length; i++) {
          list[i]['percentage'] = null
          for (let j = 0; j < list[i].task_activities.length; j++) {
            list[i].task_activities[j]['percentage'] = null
            for (let k = 0; k < list[i].task_activities[j].resources.length; k++) {
              list[i].task_activities[j].resources[k]['percentage'] = null
              let length = list[i].task_activities[j].resources[k].items.length
              for (let l = 0; l < length; l++) {
                // 添加小节评分规则
                list[i].task_activities[j].resources[k].items[l]['rule'] = 0
                let percentage = (100 / length).toFixed()
                if (length === (l + 1)) {
                  let difference = Number(100 - percentage * length)
                  list[i].task_activities[j].resources[k].items[l]['percentage'] = percentage * 1 + difference * 1
                  break
                }
                list[i].task_activities[j].resources[k].items[l]['percentage'] = Number(percentage)
              }
            }
          }
        }
        that.list = list
      })
    }

  },
  mounted() {
    this.product_id = this.$route.query.product_id;
    this.project_id = this.$route.query.project_id;
    const data = {
      token: this.$store.state.authority_management,
      product_id: this.product_id,
      shop_id: this.$store.state.store.id
    }
    const that = this
    // $isAbnormal
    that.$post('proportion/get', data).then(res => {
      if (that.$isAbnormal(res.data.result)) {
        // 调用方法获取数据并添加百分比属性和评分规则属性
        this.initList()
        this.url = 'proportion/create'
      } else {
        this.url = 'proportion/edit'
        this.list = JSON.parse(res.data.result.resources)
      }
    })
    
  }
}
